import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA } from '@angular/material/dialog'
import { externalRoute } from './external-routes'

@Component({
  template: `
    <h4>{{title}}</h4>
    <hr class="w-25 h-25 ml-0 brand-hr"><br>
    <h4 *ngIf="message" class="h4-subheader mb-3" [innerHTML]="message"></h4>
    <div *ngIf="newRequest" class="border p-3 mb-2">
      <div class="mb-1"><b>{{ improveSubmissionTitle }}</b></div>
      <div *ngFor="let check of improveSubmissionItems" class="d-flex justify-content-start align-items-center mr-1 mb-1">
        <i class="fas fa-check tiny-right-buffer mr-2"></i>
        {{check}}
      </div>
      <a *ngIf="!isVideoRequest" href="{{linkTo('improve_submissions')}}" target="_blank">Learn more</a>
    </div>

    <div class="d-flex justify-content-start mb-1" *ngIf="data.contentTypeId === 99">
      Once you've activated your request, you will not be able to make changes.
    </div>

    <label>
      <input type="checkbox" name="dismiss" [(ngModel)]="dontShowAgain" [checked]="dontShowAgain"/>
      <span class="font-weight-normal small-left-buffer">Don't show this message again</span>
    </label>

    <div class="mt-2">
    <button [mat-dialog-close]="{submit: true, dontShowAgain: dontShowAgain}" class="btn btn-primary mr-1">{{ buttonText }}</button>
    <button [mat-dialog-close]="{submit: false, dontShowAgain: dontShowAgain}" class="btn btn-outline-primary">Go Back</button>
    </div>
  `
})
export class SaveKeywordDialog {
  public dontShowAgain: boolean = false;
  isVideoRequest: boolean = false;
  message: string;
  buttonText: string;
  title: string = 'Please confirm to request content';
  newRequest: boolean = true;
  improveSubmissionTitle: string = "Want the best submissions? Include:";
  improveSubmissionItems: string[] = [
    "the action you want your readers to take",
    "the most important message to convey",
    "key details about your readers",
    "helpful resources for writers to review"
  ];
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      dontShowAgain: boolean,
      title: string,
      message: string,
      buttonText: string,
      newRequest: boolean,
      contentTypeId: number
    }
  ) {}

  ngOnInit(): void {
    this.dontShowAgain = this.data.dontShowAgain
    this.message = this.data.message
    this.buttonText = this.data.buttonText
    this.newRequest = this.data.newRequest
    if (this.data.contentTypeId === 99) {
      this.isVideoRequest = true
      this.improveSubmissionTitle = "Want the best video? Include:"
      this.improveSubmissionItems = [
        "the action you want viewers to take",
        "musical preferences",
        "image preferences",
        "words of phrases we shouldn't use"
      ]
    }
    if (this.data.title) {
      this.title = this.data.title
    }
  }

  linkTo(externalRouteKey: string): string {
    return externalRoute(externalRouteKey)
  }

}
